export enum ItalyIdType {
  CODICE_FISCALE = 'tax_id',
  PERMESSO_DI_SOGGIORNO = 'it_residence_permit',
  PASSPORT = 'passport',
  CARTA_D_IDENTITA = 'it_id_card',
}
